/**
 * Cartão de falha de carga — GUPM-336.
 *
 * Substitui o texto fixo "Confira se `supabase start` está rodando e se o `.env`
 * aponta para 127.0.0.1:54321", que aparecia para o vigilante em produção. Essa dica é
 * do desenvolvedor e só aparece em `import.meta.env.DEV`. Em produção o cartão orienta
 * em linguagem de operação, oferece o contato do suporte e mantém a mensagem técnica,
 * discreta, para quem for atender.
 *
 * O e-mail chega por prop (o container lê com `useEmailSuporteApp`, que vem do banco):
 * o cartão fica puro e testável sem provider.
 */
import { orientacaoDaFalhaDeCarga } from '@/domain/sessao/relogio';

interface FalhaDeCargaProps {
  titulo: string;
  erro: Error;
  /** E-mail do suporte (banco); `null` = nunca carregado neste navegador. */
  emailSuporte: string | null;
  /** Injetável para teste; o default é o modo do build. */
  ambienteLocal?: boolean;
}

export function FalhaDeCarga({ titulo, erro, emailSuporte, ambienteLocal = import.meta.env.DEV }: FalhaDeCargaProps) {
  return (
    <div className="text-level-emergencia rounded-xl border border-level-emergencia/40 bg-level-emergencia/10 p-4">
      <p className="font-bold">{titulo}</p>
      <p className="text-sm mt-1 text-jf-muted">{orientacaoDaFalhaDeCarga(erro.message)}</p>
      <p className="text-sm mt-1 text-jf-muted">
        {emailSuporte ? (
          <>
            Se o problema não for resolvido, entre em contato com o suporte via WhatsApp ou pelo e-mail{' '}
            <a className="underline text-jf-yellow hover:text-white" href={`mailto:${emailSuporte}`}>
              {emailSuporte}
            </a>
            .
          </>
        ) : (
          // Banco fora e nada guardado neste navegador: não inventa endereço.
          'Se o problema não for resolvido, entre em contato com o suporte via WhatsApp ou e-mail (contatos em Outros → Contatos).'
        )}
      </p>
      <p className="text-xs mt-2 text-jf-dim">
        Detalhe técnico: <span>{erro.message}</span>
      </p>
      {ambienteLocal && (
        <p className="text-xs mt-2 text-jf-dim">
          Dev: confira se <code className="text-jf-yellow">supabase start</code> está rodando
          e se o <code className="text-jf-yellow">.env</code> aponta para <code>http://127.0.0.1:54321</code>.
        </p>
      )}
    </div>
  );
}
